<template>
    <div class="learning-box" id="Learning">
        <div class="learning-box__body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewCourseSlot",
    data() {
        return {};
    },
    components: {},
    props: {}
};
</script>

<style lang="scss">
#Learning {
    .learning-box__body-head-title {
        @media (max-width: 630px) {
            display: none;
        }
    }
}
.learning-box__body-head > div {
    display: flex;
    justify-content: space-between;
}
.left-buttons {
    display: flex;
    button:first-child {
        margin-right: 24px;
    }
}
.learning-box__body-head > div {
    display: flex;
    justify-content: space-between;
}
</style>
